"use strict";
exports.__esModule = true;
exports.useStatuses = void 0;
var status_1 = require("../consts/status");
function useStatuses(opts) {
    return {
        statuses: opts.variant === "solo" ? status_1.HiylloSoloStatuses : status_1.HiylloWorkStatuses,
        colors: status_1.StatusColorMap
    };
}
exports.useStatuses = useStatuses;
